import CourseCard2 from './CourseCard2';

export default CourseCard2;
